(() => {
  const initialize = (carousel) => {
    if (carousel.dataset.tbsoReady === 'true') return;
    const rail = carousel.querySelector('[data-tbso-rail]');
    const previous = carousel.querySelector('[data-tbso-prev]');
    const next = carousel.querySelector('[data-tbso-next]');
    if (!rail || !previous || !next) return;

    const distance = () => {
      const card = rail.firstElementChild;
      const gap = Number.parseFloat(getComputedStyle(rail).columnGap || getComputedStyle(rail).gap) || 12;
      return card ? card.getBoundingClientRect().width + gap : rail.clientWidth * 0.8;
    };

    previous.addEventListener('click', () => rail.scrollBy({ left: -distance(), behavior: 'smooth' }));
    next.addEventListener('click', () => rail.scrollBy({ left: distance(), behavior: 'smooth' }));
    carousel.dataset.tbsoReady = 'true';
  };

  const initializeAll = (root = document) => root.querySelectorAll('[data-tbso-carousel]').forEach(initialize);
  document.addEventListener('DOMContentLoaded', () => initializeAll());
  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
